import fetchOnlineReviewDataReducer from "./fetchOnlineReviewDataReducer";


export default {
    fetchOnlineReviewDataReducer
}